const HeaderScroll = () => {
  const header = document.querySelector(".header");
  
  if (header) {
    window.addEventListener('scroll', () => {
      window.scrollY > 0 ? header.classList.add('scroll-collapsed') : header.classList.remove('scroll-collapsed');
    });
  }
}


export default HeaderScroll;
